module.exports = __webpack_public_path__ + "static/20181204_190626_optimized-464d642f2689c97f89956e367240d684.jpg";